export const SettlementRouting = [
  {
    path: "/projectPayment/contractSettlement/list",
    name: "contract-settlement-list",
    meta: { title: "产值结算管理" },
    component: () =>
      import(
        /* webpackChunkName: "contract-settlement" */ "@/views/project-payment/contractSettlement/list/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/projectPayment/contractSettlement/create",
    name: "contract-settlement-create",
    meta: { title: "新增产值结算",comName:"projectPaymentContractSettlementFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "contract-settlement" */ "@/views/project-payment/contractSettlement/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/projectPayment/contractSettlement/edit/:id",
    name: "contract-settlement-edit",
    meta: { title: "编辑产值结算",comName:"projectPaymentContractSettlementFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "contract-settlement" */ "@/views/project-payment/contractSettlement/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/projectPayment/contractSettlement/detail/:id",
    name: "contract-settlement-detail",
    meta: { title: "产值结算详情" },
    component: () =>
      import(
        /* webpackChunkName: "contract-settlement" */ "@/views/project-payment/contractSettlement/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/projectPayment/contractSettlement/flowPrint/:id",
    name: "contract-settlement-flow-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "contract-settlement" */ "@/views/project-payment/contractSettlement/flow-print/index.vue"
      ),
  },
];
